import styled from 'styled-components';
import { buttonReset } from '../../styled/buttons';
import { linkStyles } from '../../styled/links';
import { squareBulletPoints } from '../../styled/lists';

export const Wrapper = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const Dropzone = styled.div`
  border: ${({ $isDragActive, $errorStatus, theme }) => {
    if ($isDragActive) {
      return `4px dashed ${theme.palette.primaryLink};`;
    }
    if ($errorStatus) {
      return `4px dashed ${theme.palette.errorBorder};`;
    }
    return `4px dashed ${theme.palette.darkBackground};`;
  }}
  padding: ${({ theme }) => theme.spacing.large};
  margin-bottom: ${({ theme }) => theme.spacing.standard};

  p {
    margin-bottom: 0;
    text-align: center;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const FilesList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 0;

  li {
    display: flex;
    justify-content: space-between;
    font-size: ${({ theme }) => theme.fontsize.standard};
    margin-bottom: 0;

    ul {
      list-style: none;
      padding: 0;
      margin-bottom: 0;
    }
  }

  > li {
    border-bottom: 1px solid ${({ theme }) => theme.palette.darkBackground};
    padding: ${({ theme }) => theme.spacing.standard} 0;
  }
`;

export const ErrorsList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 0;
`;

export const RemoveButton = styled.input.attrs((props) => ({
  type: 'button',
  value: props.value || 'Remove',
}))`
  ${buttonReset};
  ${linkStyles};
`;

export const RequirementsList = styled.ul`
  ${squareBulletPoints}
  li {
    margin-bottom: ${({ theme }) => theme.spacing.tiny};
    ul li {
      margin-bottom: 0;
    }
  }
`;

export const AsideWrapper = styled.aside`
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const ScanConsent = styled.p`
  font-size: ${({ theme }) => theme.fontsize.small};
  margin-top: ${({ theme }) => theme.spacing.standard};
`;
